module.exports = __webpack_public_path__ + "static/media/104.027cdf15.png";